import React, { PropTypes } from 'react';
import { createEvent } from 'googleanalytics';
import Location from 'records/Location';
import Row from 'muicss/lib/react/row';
import Col from 'muicss/lib/react/col';
import { CATEGORIES, ACTIONS } from 'constants/googleAnalytics';
import { userPrivileges } from 'constants/user';
import Button from "muicss/lib/react/button";
import businessLogo from 'assets/img/image-placeholder.png';
import { Link } from 'react-router/es';
import { routeCodes } from 'constants/routes';

/**
 * open GMB modal and GA call when clicks
 * @param {Record} user user object
 */
const onGMBClick = (user, changeGmbVisibility) => {
const { opcoId, syscoCustomerId } = user;
createEvent(CATEGORIES.GBP, ACTIONS.OPEN_GBP_TILE, `${ opcoId }-${ syscoCustomerId }`, user);
changeGmbVisibility(true);
};

/**
 * handle tile click
 * @param {Record} card card
 * @param {Record} user user object
 * @param {Record} changeGmbVisibility GBP tile visibility
 */
const handleTileOnClick = (card, user, changeGmbVisibility) => {
  if (card.card_type === "GBP") {
    onGMBClick(user, changeGmbVisibility)
  } else {
    if (card.button.href === 'https://www.solutions.sysco.com/request-a-project') {
      onRSClick(user);
    }
    window.open(card.button.href, '_blank')
  }
}

/**
 * open RS banner click send GA call
 * @param {Record} user user object
 */
const onRSClick = (user) => {
const { opcoId, syscoCustomerId, id } = user;

createEvent(CATEGORIES.RESTAURANT_SOLUTIONS, ACTIONS.REQUEST_PROJECT, `${ opcoId }-${ syscoCustomerId }:${ id }`, user);
};

const BrandInfo = ((props) => {
const { brand, user, changeGmbVisibility, designs, menus, recipes, featureCallout } = props;
const privileges = user.get('privileges');
const isGMBLinkVisible = privileges.includes(userPrivileges.VSIBILITY_FOR_GMB_LINK);
const cards = isGMBLinkVisible ? featureCallout : featureCallout && featureCallout.filter(card => card.card_type !=='GBP');

  if (brand) {
    const imgUrl = brand.getIn(['contentFile', 'contentUrl']);
    return (
      <Row>
        <Col xs='12'>
            <div className='brand-image'>
              <img src={ imgUrl ? imgUrl : businessLogo } alt='Logo' className='full-width'/>
            </div>
        </Col>
        <Col xs="12">
          <div className="brand-data-content">
            <h4 className="brand-title mb-4">{brand.get("brandName")}</h4>
            <p className="mui--text-dark-secondary text-italic font-14">
              Account #: {user.get("opcoId")}-{user.get("syscoCustomerId")}
            </p>
            <div className="brand-description mb-4">
              <div className="brand-item-name">Designs</div>
              <div className="border-dots"></div>
              <div className="brand-item-value">
                <Link to={`${routeCodes.DESIGNS}`}>{designs}</Link>
              </div>
            </div>
            <div className="brand-description mb-4">
              <div className="brand-item-name">Menus Engineered</div>
              <div className="border-dots"></div>
              <div className="brand-item-value">
                <Link to={`${routeCodes.MENU_ENGINEERING}`}>{menus}</Link>
              </div>
            </div>
            <div className="brand-description mb-4">
              <div className="brand-item-name">Recipes</div>
              <div className="border-dots"></div>
              <div className="brand-item-value">
                <Link to={`${routeCodes.RECIPES}`}>{recipes}</Link>
              </div>
            </div>
          </div>


            { cards ? <div className='marketing-ads mt-15'>
                {cards.map((card) => {
                    return (
                      <div
                        key={card._metadata.uid}
                        className={`${!!card.theme && card.theme} marketing-ad`}
                      >
                        {card.image.length > 0 ? (
                          <div
                            className="mk-ad-img-wrapper"
                            style={{
                              backgroundImage: `url(${card.image[0].url})`,
                            }}
                          >
                          {(card.cotentstack_logo_image || card.otmm_logo_image[0]) ?
                            (<div className="mk-ad-img-secondary img-logo-rounded overflow-hidden">
                                <img 
                                  alt="ad-image"
                                  src={card.otmm_logo_image[0] ?  card.otmm_logo_image[0].url : card.cotentstack_logo_image.url}
                                  className="full-width"
                                />
                            </div>)
                            : null }
                          </div>
                        ) : null }
                        {!isEmpty(card.heading) && (
                          <div className="mk-ad-content">
                            {!!card.heading && (
                              <h4 className="mui--text-dark mt-0">
                                {card.heading}
                              </h4>
                            )}
                            {!!card.description && (
                              <p className="mui--text-dark font-12 mb-4">
                                {card.description}
                              </p>
                            )}
                            {card.button.title !== "" && (
                              <Button
                                onClick={() =>
                                  handleTileOnClick(
                                    card,
                                    user,
                                    changeGmbVisibility
                                  )
                                }
                                className="mui-btn--secondary mui-btn--small font-12 mb-0"
                              >
                                {card.button.title}
                              </Button>
                            )}
                          </div>
                        )}
                      </div>
                    );                       
                  })
                }
              </div> : null
            }

        </Col>
      </Row>
    );
  }
  return (
    <div className='brand-info-content'>
      <h3>No brand available</h3>
    </div>
  );
});

BrandInfo.propTypes = {
  brand: PropTypes.object,
  user: PropTypes.object,
  changeGmbVisibility: PropTypes.func,
  featureCallout: PropTypes.array
};

function isEmpty(obj) {
  return JSON.stringify(obj) === '{}'
}

export default BrandInfo;
